import { Component, OnInit, TemplateRef } from '@angular/core';
import { CompraService } from '../../../services/compra.service';
import { Compra } from './../../../models/compra';
import { Router } from '@angular/router';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { SweetMessage } from '../../../config/sweet-message';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { CompraModalComponent } from '../../../components/modals/compra-modal/compra-modal.component';
import { SessionService } from '../../../services/session.service';
import { ConfirmacionAnulacionModalComponent } from '../../../components/modals/confirmacion-anulacion-modal/confirmacion-anulacion-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { Pagination } from '../../../models/pagination';
import * as moment from 'moment';
import { EmitirRetencionCompraModalComponent } from '../../modals/emitir-retencion-compra-modal/emitir-retencion-compra-modal.component';
import { RetencionCompraModalComponent } from '../../modals/retencion-compra-modal/retencion-compra-modal.component';
import { AsientoContableDetalleModalComponent } from '../../modals/asiento-contable-modal/asiento-contable-detalle-modal.component';

@Component({
  selector: 'compra-list',
  templateUrl: './compra-list.component.html',
  styleUrls: ['./compra-list.component.css'],
  providers: [ CompraService, ParametroService ]
})
export class CompraListComponent implements OnInit {
	public title: String;
	public Compras: Array<Compra> = [];
	public msg: SweetMessage;
	public bsModalRef: BsModalRef;
	public bsModalRef2: BsModalRef;
	public loading = false;
	public observacion: String;
	public compra_anulada: Compra;
	public numero_decimales: number;
    public format_decimal: String;
	public pagination: Pagination;
	public Mod_FactElec: string;
	public Mod_Cartera: string;
	public Mod_Contabilidad: string;

	constructor(
		public CompraService: CompraService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private modalService: BsModalService,
		private ss: SessionService,
		private parametroService: ParametroService,
		
	) {
		this.title = "Compras";
		//this.busy = false;
		this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.pagination = new Pagination();
		this.Mod_FactElec = this.ss.getData("mod_felectronica");
		this.Mod_Cartera = this.ss.getData("mod_cartera");
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
	}

	ngOnInit() {
		this.msg = new SweetMessage();
		
		this.loading = true;
		let p1 = this.getParamNumeroDecimales();
		let p2 = this.getCompras();
		
		Promise.all([p1,p2]).then(
			res => this.loading = false,
			err => this.loading = false,
		);
	}

	// getCompras(){
	// 	return new Promise((resolve, reject) => {
	// 		let now = moment();
       		
	// 		this.CompraService.getAll("?page=" + this.pagination.current_page + "&per_page=10&fecha_emision="+moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format()+"&embed=proveedor,tipocomprobante,retencion&sort=-fecha_emision,-secuencial&status=A&usuario_id="+this.ss.getData('usuario_id')).subscribe(
	// 			res => {
	// 				if( !res.data.length ){
	// 					this.Compras = [];
	// 				}else{
	// 					this.Compras = res.data;
	// 					// Paginación
	// 					this.pagination.current_page = res.current_page;
	// 					this.pagination.from = res.from;
	// 					this.pagination.to = res.to;
	// 					this.pagination.total = res.total;
	// 					this.pagination.last_page = res.last_page;
	// 					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
	// 					this.pagination.prev_disabled = this.pagination.current_page === 1;
	// 				}
	// 				resolve();
	// 			},
	// 			err => {
	// 				this.Compras = [];
	// 				reject();
	// 			}
	// 		);
	// 	});
	// }

	getCompras(){
		return new Promise((resolve, reject) => {
			let now = moment();

			// let tipo_comprobante_id = "";
			// if(this.Mod_FactElec){
			// 	tipo_comprobante_id = "4";
			// }
			// else{
			// 	tipo_comprobante_id = "1";
			// }
			//&tipo_comprobante_id="+ tipo_comprobante_id +"
		//	this.CompraService.getAll("?page=" + this.pagination.current_page + "&per_page=10&fecha_emision="+moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format()+"&embed=proveedor,tipocomprobante&sort=-fecha_emision,-secuencial&status=A&tipo_comprobante_id=1&usuario_id="+this.ss.getData('usuario_id')).subscribe(
			   
			this.CompraService.getAll("?page=" + this.pagination.current_page + "&per_page=10&fecha_emision="+moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format()+"&embed=proveedor,asientocontable,tipocomprobante,retencion&sort=-fecha_emision,-secuencial&status=A&in[tipo_comprobante_id]=1,4&usuario_id="+this.ss.getData('usuario_id')).subscribe(
				res => {
					if( !res.data.length ){
						this.Compras = [];
					}else{
						this.Compras = res.data;
						// Paginación
						this.pagination.current_page = res.current_page;
						this.pagination.from = res.from;
						this.pagination.to = res.to;
						this.pagination.total = res.total;
						this.pagination.last_page = res.last_page;
						this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
						this.pagination.prev_disabled = this.pagination.current_page === 1;
					}
					resolve(true);
				},
				err => {
					this.Compras = [];
					reject();
				}
			);
		});
	}

	// getComprasPromise = (resolve, reject) => {
	// 	let now = moment();
		   
	// 	this.CompraService.getAll("?page=" + this.pagination.current_page + "&per_page=10&fecha_emision="+moment(now.format("YYYY-MM-DD"), moment.ISO_8601).format()+"&embed=proveedor,tipocomprobante,retencion&sort=-fecha_emision,-secuencial&status=A&usuario_id="+this.ss.getData('usuario_id')).subscribe(
	// 		res => {
	// 			if( !res.data.length ){
	// 				this.Compras = [];
	// 			}else{
	// 				this.Compras = res.data;
	// 				// Paginación
	// 				this.pagination.current_page = res.current_page;
	// 				this.pagination.from = res.from;
	// 				this.pagination.to = res.to;
	// 				this.pagination.total = res.total;
	// 				this.pagination.last_page = res.last_page;
	// 				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
	// 				this.pagination.prev_disabled = this.pagination.current_page === 1;
	// 			}
	// 			resolve();
	// 		},
	// 		err => {
	// 			this.Compras = [];
	// 			reject();
	// 		}
	// 	);
	// }

	getIndexNumber(i){
        return this.pagination.from+i;
	}
	
	next(){
        this.pagination.current_page++;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	prev(){
        this.pagination.current_page--;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	first(){
        this.pagination.current_page = 1;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}

	last(){
        this.pagination.current_page = this.pagination.last_page;
        this.loading = true;
		this.getCompras().then(
            res => this.loading = false,
            err => this.loading = false
        );
	}
	parseTipo(tipo){
		if( tipo === "CR" ){
			return "Crédito";
		}else{
			return "Contado";
		}
    }

	showModal(){

	}

	onShow(id){
		const initialState = {compra_id: id, numero_decimales: this.numero_decimales};
		this.bsModalRef = this.modalService.show(CompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onShowAsiento(asiento){
		const initialState = {asiento_id: asiento.id, tipo_transaccion_contabilidad_id: asiento.tipo_transaccion_contabilidad_id};
		this.bsModalRef = this.modalService.show(AsientoContableDetalleModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
  	}

	onEdit(compra) {
		this.storage.setItem("compra", compra).subscribe(() => {
			this.NavRoute.navigate(['/compras/compras-edit']);
		});
	}

	/*onDelete(id){
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if(res == "ok"){
					this.CompraService.delete(id).subscribe(
						res => {
							if(res.message){
								this.getCompras();
								this.msg.showMessage('success-message',res.message);
							}
						},
						err => {
							this.msg.showMessage('error-message', err);
						}
					);
				}
			}
		);
	}*/

	getNumeroDocumento(compra){
		return compra.serie + "-" + compra.punto_emision + "-" + compra.secuencial;
	}

	openModalObservacion(template: TemplateRef<any>, compra: Compra) {
		this.observacion = compra.observacion;
		this.compra_anulada = compra;
		this.bsModalRef = this.modalService.show(template);
		this.bsModalRef2 = this.bsModalRef;
	}

	anularCompra(){
		this.bsModalRef2.hide();
		let preg = "¿Está seguro de querer eliminar el documento?";
		const initialState = { Pregunta: preg, Respuesta:false };
		this.bsModalRef = this.modalService.show(ConfirmacionAnulacionModalComponent, Object.assign({}, {initialState}));

		this.bsModalRef.content.action.take(1).subscribe((Respuesta) => {
			if(Respuesta == true){
				this.compra_anulada.observacion = this.observacion.toString().trim();
				this.compra_anulada.usuario_id = this.ss.getData("usuario_id");
				this.observacion  = "";
				
				this.loading = true;

				this.CompraService.anular(this.compra_anulada).subscribe(
					res => {
						this.bsModalRef.hide();
						this.compra_anulada = new Compra();

						this.msg.showMessage('success-message', 'Se ha procesado correctamente');

						this.getCompras().then(
							res => {
								this.loading = false;
							},
							err => {
								this.loading = false;
							}
						);
					},
					err => {
						this.loading = false;
					}
				);
			}
			else{
				return;
			}
		});
	}

	getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve(true);
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
    }

    get formatDecimal(){
        return this.format_decimal;
	}
	
	openEmitirRetencionCompraModal(compra) {
		const initialState = { compra_id: compra.id, modal: true };
		this.bsModalRef = this.modalService.show(EmitirRetencionCompraModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		let promise = new Promise((resolve, reject) => {
			this.bsModalRef.content.cerrarModal.take(1).subscribe(value => {
				resolve(value.isSaved);
			})
		});

		promise.then(isSaved => {
			if( !isSaved ) return;

			this.loading = true;
			this.getCompras().then(
				res => this.loading = false,
				err => this.loading = false,
			);
		});
    }
    
    openVerRetencion(retencion_id){
        const initialState = {retencion_id: retencion_id};
        this.bsModalRef = this.modalService.show(RetencionCompraModalComponent, Object.assign({}, {class: 'modal-xlg', initialState}));
    }
}




// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/compras/compra-list/compra-list.component.ts